import { Component, Input, OnInit } from '@angular/core';
import { ModalType } from '@challenger6/vm-pattern-library/modal';
import { StrapiGenericComponentService } from '../../services/strapi-generic-component.service';

@Component({
  selector: 'vm-modal-with-link',
  templateUrl: './modal-with-link.component.html',
  styleUrls: ['./modal-with-link.component.scss'],
})
export class ModalWithLinkComponent implements OnInit {
  @Input() preLabel: string;
  @Input() label: string;
  @Input() postLabel: string;
  @Input() title: string;
  @Input() copy: string;
  @Input() uid: string;
  @Input() modalType = ModalType.Standard;

  isModalOpen = false;

  constructor(private strapiGenericComponentService: StrapiGenericComponentService) {}

  ngOnInit(): void {
    if (this.uid) {
      this.fetchContent();
    }
  }

  openModal(e): boolean {
    e.preventDefault();
    this.isModalOpen = true;
    //todo: confirm if we need below
    //this.priorityCallService.createPriorityCallMTD(e);
    //this.secondaryModalOpened.emit();
    return false;
  }

  private fetchContent() {
    this.strapiGenericComponentService.fetchContent(this.uid, false).subscribe((result) => {
      this.label = result?.actions[0]?.label;
      this.title = result?.title;
      this.copy = result?.info;
    });
  }
}
